<template>
  <div>
    <div class="deposit">
      <h3>充值福利</h3>
      <ul class="mt20 u-flex ">
        <li :class="{ 'active': curIndex === index }" v-for="(item, index) in list" :key="item.id"
            @click="onTab(item, index)">
          <img class="icon" src="../assets/images/wd_pic1.png" alt="" v-if="curIndex === index">
          <div class="money" v-if="item.money">{{ item.money }}元</div>
          <div class="present" v-if="item.gift && parseFloat(item.gift) > 0">赠送{{ item.gift }}</div>
        </li>
      </ul>
    </div>

    <div class="custom-amount">
      <h3>自定义金额</h3>
      <el-input v-model="customMoney" placeholder="请输入充值金额" type="number" @input="onCustomAmountChange"
                class="custom-input">
        <template slot="append">元</template>
      </el-input>
    </div>

    <div class="pay">
      <h3>支付方式</h3>
      <div class="payment-options">

        <div class="payment-option" :class="{ active: pay === 'alipay' }" @click="pay = 'alipay'">
          <img src="../assets/images/gmdl_zhifubao.png" alt="支付宝"/>
          <span>支付宝</span>
        </div>
<!--        <div class="payment-option" :class="{ active: pay === 'wechat' }" @click="pay = 'wechat'">-->
<!--          <img src="../assets/images/gmdl_weixin.png" alt="微信"/>-->
<!--          <span>微信</span>-->
<!--        </div>-->
      </div>
      <span class="pay-button" slot="btn">
        <el-button type="primary" class="pay-now-btn" @click="handlePay">立即充值</el-button>
      </span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Dialog',

  data() {
    return {
      curIndex: null,
      selectedItem: null,
      list: [],
      customMoney: '',
      pay: 'alipay'
    }
  },

  mounted() {
    this.getData()
  },

  methods: {
    getData() {
      this.$api.recharge.rechargeList().then(res => {
        this.list = res.data
        // 默认选中第一个
        if (this.list.length > 0) {
          this.onTab(this.list[0], 0)
        }
      })
    },

    onTab(item, index) {
      this.curIndex = index
      this.selectedItem = item
      // 自动填入自定义金额输入框
      this.customMoney = item.money
      this.$emit('tab', item)
    },

    onCustomAmountChange(value) {
      // 当用户输入自定义金额时，清除选中状态
      if (value && value !== (this.selectedItem && this.selectedItem.money)) {
        this.curIndex = null
        this.selectedItem = null
      }
      this.$emit('custom-amount-change', value)
    },

    formatTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      return date.toLocaleDateString('zh-CN') + ' ' + date.toLocaleTimeString('zh-CN', {
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    // 获取当前选中的充值信息
    getSelectedRechargeInfo() {
      if (this.customMoney && this.customMoney !== (this.selectedItem && this.selectedItem.money)) {
        // 自定义金额
        return {
          type: 'custom',
          amount: parseFloat(this.customMoney),
          paymentMethod: this.pay,
          customAmount: true
        }
      } else if (this.selectedItem) {
        // 选择预设金额
        return {
          type: 'preset',
          item: this.selectedItem,
          amount: parseFloat(this.selectedItem.money),
          paymentMethod: this.pay,
          customAmount: false
        }
      }
      return null
    },

    // 处理支付
    handlePay() {
      const rechargeInfo = this.getSelectedRechargeInfo()
      if (!rechargeInfo) {
        this.$message.warning('请选择充值金额')
        return
      }

      // 验证支付方式
      if (!this.pay) {
        this.$message.warning('请选择支付方式')
        return
      }

      // 构建支付参数
      const payParams = {
        amount: rechargeInfo.amount,
        paymentMethod: this.pay
      }

      // 如果是预设金额，添加福利ID
      if (rechargeInfo.type === 'preset' && rechargeInfo.item) {
        payParams.benefitId = rechargeInfo.item.id
      }


      // 调用充值API
      this.$api.recharge.rechargeMoney(payParams).then(res => {


        // 根据支付方式处理不同的响应
        if (this.pay === 'wechat') {
          // 微信支付 - 弹出框显示二维码
          this.showWechatPayDialog(res.data)
        } else if (this.pay === 'alipay') {
          // 支付宝支付 - 跳转到支付页面
          this.redirectToAlipay(res.data.data)
        } else {
          // 其他支付方式
          this.$message.success('充值请求已提交')
        }
      }).catch(err => {
        this.$message.error('充值失败：' + (err.message || '未知错误'))
      })
    },

    // 显示微信支付弹窗
    showWechatPayDialog(payData) {

      // 获取二维码数据，支持多种字段名和base64格式
      let qrCodeData = payData.data.wechat_data || payData.data.wechat_data || payData.data.wechat_data || ''

      // 如果是base64格式，需要添加data:image前缀
      if (qrCodeData && !qrCodeData.startsWith('data:image') && !qrCodeData.startsWith('http')) {
        // 假设返回的是纯base64数据，添加图片前缀
        qrCodeData = `data:image/png;base64,${qrCodeData}`
      }

      // 创建微信支付弹窗
      this.$confirm(
          `<div style="text-align: center;">
          <h3>微信扫码支付</h3>
          <div style="margin: 20px 0;">
            <img src="${qrCodeData}" alt="微信支付二维码" style="max-width: 200px; height: auto; border: 1px solid #eee; border-radius: 4px;">
          </div>

          <p style="color: #ff6b35; font-weight: bold;">支付金额：¥${this.getSelectedRechargeInfo().amount}</p>

        </div>`,
          '微信支付',
          {
            confirmButtonText: '支付完成',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            customClass: 'wechat-pay-dialog',
            showCancelButton: true,
            center: true
          }
      ).then(() => {
        this.$router.push({
          path: '/pay-status',
          query: {
            order_sn: payData.order_sn
          }
        })
      }).catch(() => {

      })
    },

    // 跳转到支付宝支付
    redirectToAlipay(payData) {
      if (payData.alipay_data) {
        // 如果有HTML内容，打开新窗口
        const newWindow = window.open()
        newWindow.document.write(payData.alipay_data)
        newWindow.document.close()
      } else {
        this.$message.error('支付宝支付链接获取失败')
      }
    }
  }
}
</script>

<style scoped>
.deposit {
  padding: 20px;
  background: #f5f5f5;
}

.deposit h3 {
  color: #999;
  font-size: 16px;
  margin-bottom: 15px;
}

.deposit ul {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.deposit li {
  position: relative;
  padding: 20px 12px;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
  background: #fff;
  box-sizing: border-box;
  border: 1px solid #d4d4d4;
  flex: 1;
  min-width: 100px;
  max-width: 140px;
  transition: all 0.3s ease;
}

.deposit .active {
  border: 1px solid #ff8415;
  background: #fff8f0;
}

.icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
}

.money {
  height: 32px;
  line-height: 32px;
  color: #000;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.present {
  padding: 5px 10px;
  color: #f8000e;
  font-size: 12px;
  border-top: 1px solid #eee;
  margin-top: 10px;
  margin-bottom: 5px;
}

.effective-time {
  font-size: 10px;
  color: #999;
  margin-top: 5px;
}

.custom-amount {
  padding: 20px;
//background: #f5f5f5; margin-top: 10px;
}

.custom-amount h3 {
  color: #999;
  font-size: 16px;
  margin-bottom: 15px;
}

.custom-input {
  max-width: 300px;
}


.pay {
  padding: 20px;
//background: #f5f5f5; margin-top: 10px;
}

.pay h3 {
  color: #999;
  font-size: 16px;
  margin-bottom: 15px;
}

.payment-options {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.payment-option {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border-radius: 8px;
  border: 1px solid #d4d4d4;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  flex: 1;
  justify-content: center;
}

.payment-option.active {
  border-color: #409eff;
  background: #ecf5ff;
}

.payment-option img {
  margin-right: 8px;
  width: 24px;
  height: 24px;
}

.payment-option span {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.pay-button {
  text-align: center;
}

.pay-now-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .deposit li {
    min-width: 100px;
    padding: 15px 10px;
  }

  .payment-options {
    flex-direction: column;
  }

  .payment-option {
    justify-content: center;
  }
}

/* 微信支付弹窗样式 */
::v-deep .wechat-pay-dialog {
  width: 400px;
}

::v-deep .wechat-pay-dialog .el-message-box__content {
  padding: 30px 20px;
}

::v-deep .wechat-pay-dialog .el-message-box__header {
  background: #07c160;
  color: white;
  padding: 15px 20px;
}

::v-deep .wechat-pay-dialog .el-message-box__title {
  color: white;
  font-weight: 600;
}

::v-deep .wechat-pay-dialog .el-message-box__headerbtn .el-message-box__close {
  color: white;
}

::v-deep .wechat-pay-dialog .el-message-box__btns {
  padding: 15px 20px;
  text-align: center;
}

::v-deep .wechat-pay-dialog .el-button--primary {
  background: #07c160;
  border-color: #07c160;
}

::v-deep .wechat-pay-dialog .el-button--primary:hover {
  background: #06ad56;
  border-color: #06ad56;
}
</style>
